import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { pushSave } from "./appSlice";

export interface ListState {
  // creationTime: string;
  id: string;
  name: string;
  description: string;
  pointsLimit?: number;
  gameSystem: string;

  communityList?: boolean;
  campaignMode?: boolean;
  narrativeMode?: boolean;
  forceOrg?: boolean;
  key?: string;

  isCloud: boolean;
  modified: string;
  cloudModified: string;
  versionChanged?: boolean;

  // Checkbox options?
  simpleMode?: boolean;
  includeVehicles?: boolean; // Skirmish only
  swarmMode?: boolean; // Quest AI only
  removeOvercosted?: boolean;
}

const initialState: ListState = {
  id: undefined,
  name: null,
  description: null,
  pointsLimit: 0,
  //points: 0,
  communityList: false,
  campaignMode: false,
  narrativeMode: false,
  simpleMode: false,
  forceOrg: false,
  gameSystem: null,
  isCloud: false,
  modified: null,
  cloudModified: null,
  versionChanged: false
};

const listSlice = createSlice({
  name: "list",
  initialState,
  reducers: {
    resetList() {
      return initialState;
    },
    createList(_state, action: PayloadAction<ListState>) {
      return action.payload;
    },
    listModified(state, action: PayloadAction<string>) {
      state.modified = action.payload;
    },
    dismissVersionChanged(state) {
      state.versionChanged = false;
    },
    updateListId(state, action: PayloadAction<string>) {
      state.id = action.payload;
    },
    updateListSettings(
      state,
      action: PayloadAction<{
        name: string;
        description: string;
        pointsLimit?: number;
        forceOrg: boolean;
        narrativeMode: boolean;
        campaignMode: boolean;
      }>
    ) {
      const { name, description, pointsLimit, forceOrg, narrativeMode, campaignMode } = action.payload;
      state.name = name;
      state.description = description;
      state.pointsLimit = pointsLimit;
      state.forceOrg = forceOrg;
      state.narrativeMode = narrativeMode;
      state.campaignMode = campaignMode;
      if (narrativeMode === false) {
        // if the new mode is DISABLED narrative, we "purge" all narrative heroes form the list
        // state.units = state.units.filter(unit => !unit.isNarrative);
      }
    },
    loadSavedList(state, action: PayloadAction<ListState>) {
      return {
        ...action.payload,
        forceOrg: action.payload.forceOrg ?? true
      };
    }
  },
  extraReducers(builder) {
    builder.addCase(pushSave.fulfilled, (state, _) => {
      state.cloudModified = state.modified;
    });
  }
});

// Action creators are generated for each case reducer function
export const {
  resetList,
  createList,
  loadSavedList,
  updateListSettings,
  listModified,
  dismissVersionChanged,
  updateListId
} = listSlice.actions;

export default listSlice.reducer;
